import { ReactElement } from "react";
import { LoadMoreIndicator as LoadMoreIndicatorComponent } from "../LoadMoreIndicator/LoadMoreIndicator";

export type LoadMoreIndicatorProps = {
	isBusy: boolean;
	hasMoreItems: boolean;
	onRequestMoreItems(): void;
};

export const LoadMoreIndicator = (props: LoadMoreIndicatorProps): ReactElement | null => {
	const {
		isBusy,
		hasMoreItems,
		onRequestMoreItems
	} = props;

	return (
		<LoadMoreIndicatorComponent
			isLoadingData={isBusy}
			hasMoreItems={hasMoreItems}
			onRequestMoreItems={onRequestMoreItems}
		/>
	);
};
LoadMoreIndicator.displayName = "VirtualList.LoadMoreIndicator";